import Printer from "@redotech/redo-icons/printer.svg";
import QrCode from "@redotech/redo-icons/qr-code-01.svg";
import { Trackable, TrackableType } from "@redotech/redo-model/trackable";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { useMemo } from "react";
export function LabelButtons({
  trackable,
  carrier,
  commercialInvoice,
}: {
  trackable: Trackable & { type: TrackableType.RETURN };
  carrier: string | undefined;
  commercialInvoice: string | null | undefined;
}) {
  function openUrl(url: string) {
    window.open(url, "_blank");
  }

  const labelButtons = useMemo(() => {
    if (trackable.shipments?.length) {
      return trackable.shipments.map((shipment, index) => (
        <RedoButton
          hierarchy="secondary"
          IconLeading={Printer}
          key={index}
          onClick={() => openUrl(shipment?.postage_label || "")}
          text={
            trackable.shipments?.length && trackable.shipments?.length > 1
              ? `Print label ${index + 1}`
              : "Print label"
          }
        />
      ));
    }
    return null;
  }, [trackable.shipments]);

  return (
    <Flex flexDirection="row" gap="sm" grow={1} pt="xs">
      {labelButtons}
      {!!trackable.form_label && !trackable.pickup && carrier != "UPS" && (
        <Flex>
          <RedoButton
            hierarchy="secondary"
            IconLeading={QrCode}
            onClick={() =>
              trackable.form_label && openUrl(trackable.form_label)
            }
            text="QR code"
          />
        </Flex>
      )}
      {!!commercialInvoice && (
        <RedoButton
          hierarchy="secondary"
          onClick={() => openUrl(commercialInvoice)}
          text="Print commercial invoice"
        />
      )}
    </Flex>
  );
}
